export default "__VITE_ASSET__CBmc1Hgt__"